<div class="animated fadeIn">
  <div class="card">
    <div class="card-header">
      <div class="row m-0">
        <div class="card mb-0 p-0 mr-1" *ngFor="let cat of categories">
          <div class="card-block p-0 clearfix">
            <ul class="nav navbar-nav ml-auto">
              <li class="nav-item">
                <a
                  [routerLink]="['/menu/list', {type: cat.type}]"
                  (click)="emptyMailList()"
                  href="javascript:void(0);"
                  role="button"
                  class="nav-link p-0 text-primary"
                  title="{{cat.visual}}"
                >
                  <i
                    *ngIf="cat.type == 'I'"
                    [ngClass]="{'btn-info' : cat.type != type}"
                    class="fa fa-{{cat.icon}} btn-primary p-1 font-md"
                  ></i>
                  <span *ngIf="cat.type == 'I'" class="mx-1 hidden-sm-down">{{visuals.inbox}}</span>
                  <i
                    *ngIf="cat.type == 'D'"
                    [ngClass]="{'btn-info' : cat.type != type}"
                    class="fa fa-{{cat.icon}} btn-primary p-1 font-md"
                  ></i>
                  <span
                    *ngIf="cat.type == 'D'"
                    class="mx-1 hidden-sm-down"
                    >{{visuals.deleted}}</span
                  >
                </a>
              </li>
            </ul>
          </div>
        </div>

        <ul class="nav navbar-nav ml-auto">
          <li class="nav-item dropdown" dropdown (onToggle)="toggled($event)">
            <a
              data-toggle="dropdown"
              href="javascript:void(0);"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
              dropdownToggle
              class="nav-link p-0 text-primary"
              title="Options"
            >
              <i class="fa fa-dots btn-default p-1 font-md"></i>
            </a>

            <div
              class="dropdown-menu dropdown-menu-right"
              *dropdownMenu
              aria-labelledby="simple-dropdown"
            >
              <!--   <a class="dropdown-item" href="javascript:void(0);" (click)='readAction()'><i class="fa fa-bookmark text-primary"></i> Mark as Read</a> -->
              <a
                *ngIf="type == 'I'"
                class="dropdown-item"
                href="javascript:void(0);"
                (click)="deleteAction()"
                ><i class="fa fa-trash text-danger"></i> {{genericVisuals.delete}}</a
              >
              <a
                *ngIf="type == 'D'"
                class="dropdown-item"
                href="javascript:void(0);"
                (click)="restoreAction()"
                ><i class="fa fa-refresh text-primary"></i>{{genericVisuals.restore}}</a
              >
              <a class="dropdown-item" href="javascript:void(0);" (click)="selectAll()"
                ><i class="fa fa-check text-primary"></i>{{genericVisuals.selectAll}}</a
              >
              <a class="dropdown-item" href="javascript:void(0);" (click)="deselectAll()"
                ><i class="fa fa-close text-danger"></i>{{genericVisuals.deselectAll}}</a
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="searched && loading" class="dataLoader"></div>

    <div *ngIf="count==0 && searched && !loading">
      <div class="alert alert-danger col-12 text-center mb-0" name="alert" role="alert">
        <i class="fa fa-search fa-2x"></i>
        <div>{{genericVisuals.nodata}}</div>
      </div>
    </div>

    <div *ngIf="searched && count>0 && !loading">
      <div class="card-block">
        <div class="row">
          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-striped table-hover condensed pointer">
                <tbody>
                  <tr *ngFor="let dato of grid; let i = index">
                    <td class="td-label td-label-muted text-center">
                      <label class="csscheckbox csscheckbox-default">
                        <input
                          type="checkbox"
                          (click)="addToMailList(dato.mailId)"
                          [checked]="isSelected(dato.mailId)"
                        /><span class="fa fa-lg"></span>
                      </label>
                    </td>
                    <td [routerLink]="['/menu/details' , {id: dato.mailId}]">
                      <blockquote class="border-left-0 mb-0 h-6-important">
                        <strong
                          *ngIf="dato.isRead == 0"
                          class="text-brand-primary-1"
                          >{{dato.sender}}</strong
                        >
                        <span
                          *ngIf="dato.isRead == 1"
                          class="text-brand-primary-2 "
                          >{{dato.sender}}</span
                        >

                        <strong
                          *ngIf="dato.isRead == 0"
                          class="text-brand-primary-1 "
                          >{{dato.subject}}</strong
                        >
                        <span
                          *ngIf="dato.isRead == 1"
                          class="text-brand-primary-2 "
                          >{{dato.subject}}</span
                        >

                        <p class="text-muted text-truncate hidden-sm-down mt-05">{{dato.body}}</p>

                        <footer class="blockquote-footer text-muted ">
                          {{dato.sendDt | date:'short'}}
                        </footer>
                      </blockquote>
                    </td>
                    <td class="text-right "><em></em></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer" style="text-align: center;">
        <div class="row">
          <div class="col-12">
            <nav aria-label="page result size" class="float-sm-none float-md-right">
              <ul class="pagination justify-content-start p-0 display-block">
                <li
                  class="page-item"
                  [ngClass]="{'active': pageSize == 20}"
                  (click)="handleChangePageSize(20)"
                >
                  <a class="page-link" href="javascript:void(0);">20</a>
                </li>
                <li
                  class="page-item"
                  [ngClass]="{'active': pageSize == 50}"
                  (click)="handleChangePageSize(50)"
                >
                  <a class="page-link" href="javascript:void(0);">50</a>
                </li>
                <li
                  class="page-item"
                  [ngClass]="{'active': pageSize == 100}"
                  (click)="handleChangePageSize(100)"
                >
                  <a class="page-link" href="javascript:void(0);">100</a>
                </li>
              </ul>
            </nav>

            <form (ngSubmit)="handleChangePage(pageNum,'full')">
              <nav aria-label="table page navigation" class="float-sm-none float-md-left">
                <ul class="pagination justify-content-center p-0 display-block">
                  <li class="page-item" [ngClass]="{'disabled pagedisabled': pageNum == 1}">
                    <a
                      class="page-link"
                      aria-label="Previous"
                      (click)="handleChangePage(pageNum, 'prev')"
                      href="javascript:void(0);"
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">{{genericVisuals.previous}}</span>
                    </a>
                  </li>
                  <li class="page-item">
                    <input
                      class="form-control page-link text-center"
                      type="text"
                      id="pagination"
                      name="pagination"
                      size="2"
                      [(ngModel)]="pageNum"
                      pattern="^[1-9]\d*$"
                      oninvalid="setCustomValidity('Only numbers!')"
                    />
                  </li>
                  <li class="page-item disabled">
                    <a class="page-link" href="javascript:void(0);">{{pageMax}}</a>
                  </li>

                  <li class="page-item" [ngClass]="{'disabled pagedisabled': pageNum == pageMax}">
                    <a
                      class="page-link"
                      aria-label="Next"
                      (click)="handleChangePage(pageNum, 'next')"
                      href="javascript:void(0);"
                    >
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">{{genericVisuals.next}}</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
